export default {
    "kt": "Khởi tạo",
    "cxk": "Chờ xuất kho",
    "dxk": "Đã xuất kho",
}
